// round.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { AppSettings } from '../_common/constants/app.constants';

/**
 *
 */
@Pipe({ name: 'round' })
export class RoundPipe implements PipeTransform {
  /**
   *
   * @param value
   * @returns {number}
   */
  transform(value: string): string {
    return parseFloat(value).toFixed(AppSettings.fractionDigit);
  }

  round(number, precision) {
    var factor = Math.pow(10, precision);
    var tempNumber = number * factor;
    var roundedTempNumber = Math.round(tempNumber);
    return roundedTempNumber / factor;
  }
}

@Pipe({ name: 'titleCase' })
export class TitleCasePipe implements PipeTransform {
  public transform(input: string): string {
    if (!input) {
      return '';
    } else {
      return input.replace(/\w\S*/g, txt => txt[0].toUpperCase() + txt.substr(1).toLowerCase());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/round.ts